export enum EAdvancedFilterLogic {
  AND = 'AND',
  OR = 'OR',
  NOR = 'NOR',
  NAND = 'NAND',
}
